function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerLocaleKeys from '../../../../../../locales/keys';
import { NUMBER_OF_CAROUSEL_ITEMS_TO_DISPLAY } from '../services.and.offers.contants';
import i18n from 'invision-core/src/components/i18n/i18n';
import { OFFER_STATUS_INDICATOR_STATUS } from 'invision-core/src/constants/status.constants';
var OfferingThumbnailController = /*#__PURE__*/function () {
  function OfferingThumbnailController($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, OfferingThumbnailController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      CustomerLocaleKeys: CustomerLocaleKeys,
      NUMBER_OF_CAROUSEL_ITEMS_TO_DISPLAY: NUMBER_OF_CAROUSEL_ITEMS_TO_DISPLAY,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(OfferingThumbnailController, [{
    key: "statusTitle",
    get: function get() {
      if (this.offering && this.offering.offerDetails.Status === OFFER_STATUS_INDICATOR_STATUS.PENDING_ACTIVE) {
        return i18n.translate(CustomerLocaleKeys.OFFER_STATUS.PENDING_ACTIVE);
      }
      return null;
    }
  }]);
}();
export default {
  bindings: {
    currency: '<',
    offering: '<'
  },
  template: require('./offering.thumbnail.html'),
  controller: OfferingThumbnailController
};